import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export default class GetUserTakeoutListService extends Service {
  constructor({repository, service}) {
    super({repository, service})

    this._repository = repository
    this._service = service
  }

  /**
   * @return {Promise<ValueObject, Error>}
   */
  async execute({useTranscendAPI = false} = {}) {
    const userEntity = await this._service.execute()
    return this._repository.getUserTakeoutList({userEntity, useTranscendAPI})
  }
}
